"use client";
import cn from "classnames";
import { type PropsWithChildren, useState } from "react";
import Backdrop from "@/components/common/Backdrop";
import s from "./ZoomImage.module.scss";

export default function ZoomImage({ children }: PropsWithChildren) {
  const [zoomed, setZoomed] = useState(false);

  const handleOpen = () => {
    setZoomed(true);
  };

  const handleClose = () => {
    setZoomed(false);
  };

  return (
    <>
      <div
        onClick={handleOpen}
        className={cn(s.zoomableImage, "informa-zoomable-image")}
      >
        {children}
      </div>
      <Backdrop open={zoomed} onClose={handleClose}>
        <div className={cn(s.zoomedImage, "informa-zoomed-image")}>
          {children}
        </div>
      </Backdrop>
    </>
  );
}
